import { render, staticRenderFns } from "./JobCardList.vue?vue&type=template&id=27d33294&"
import script from "./JobCardList.vue?vue&type=script&lang=js&"
export * from "./JobCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports